module.exports = __webpack_public_path__ + "static/media/login-img.3e37523c.png";